import React from "react";

export default function SupportedBlockchains() {
	return (
		<section id="SupportedTokens">
			<div className="container">
				<h2 className="mb-4">Supported Tokens</h2>
				<div className="token-row">
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-eth.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-usdt.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-wbtc.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-bnb.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-movr.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-matic.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-avax.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-usdc.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-aave.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-crv.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-dai.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-sushi.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-busd.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-vesolar.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-syn.png" />
				    </div>
				    <div className="token">
				        <img src="assets/imgs/logos/tokens/token-gohm.png" />
				    </div>
				</div>
			</div>
		</section>
		);
}